export default __webpack_public_path__ + "static/media/twitter_logo.f963dcac.png";